import {
  RiskFactorBreakdown,
  RiskMilestoneTable,
  RiskOrganizationPanel,
  RiskScoreCard,
  useSiteRisk,
} from "@/components/Risk/siteRisk";
import type { MasteredSite } from "../types";

/**
 * Site delay risk at the mastered-site grain: the score and band, what drove
 * it, and the startup milestones underneath. Explanation stops at factor level
 * by design — drill-through to the underlying documents is the Documents tab,
 * so this panel can be shown to a role that should see the reasons for a score
 * without inheriting the corpus behind them.
 */
export default function RiskTab({ site }: { site: MasteredSite }) {
  const { data: risk, isLoading } = useSiteRisk(site.site_key);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-48 text-gray-400 text-[13px]">
        Loading…
      </div>
    );
  }

  if (!risk) {
    return (
      <div className="flex items-center justify-center h-48 text-gray-400 text-[13px]">
        No risk data available for this site.
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <RiskScoreCard risk={risk} />
      {risk.scored ? (
        <RiskFactorBreakdown factors={risk.factors ?? []} />
      ) : null}
      <RiskMilestoneTable milestones={risk.milestones} />
      {risk.organization ? (
        <RiskOrganizationPanel organization={risk.organization} />
      ) : null}
    </div>
  );
}
